var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccesoriesIconGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "31px",
    viewBox: "0 0 34 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun-video-game-console-112148") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navdropdown-V2.0",
    transform: "translate(-564.000000, -192.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-video-game-console-112148",
    transform: "translate(565.000000, 193.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.396051,28.6244401 C18.6658637,30.6644073 15.5822842,23.7290408 12.0323727,23.7290408 C8.56553139,23.7290408 4.41939016,30.2562398 1.59299335,28.6244401 C-0.651175094,27.328501 -0.40732384,19.3094019 1.59299335,17.6087039 C5.68292821,14.1297068 18.3061831,14.1311573 22.3967209,17.6087039 C24.397708,19.3092568 24.6671503,27.383547 22.3960476,28.6244401 L22.396051,28.6244401 Z",
    id: "Path",
    stroke: "#525252",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 19,
    x2: 19,
    y2: 23,
    id: "Path",
    stroke: "#525252",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 21,
    x2: 17,
    y2: 21,
    id: "Path",
    stroke: "#525252",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 18.5,
    x2: 14,
    y2: 18.5,
    id: "Path",
    stroke: "#525252",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9929271,15 C12.9929271,14.1907345 13.0088411,13.3814691 12.9929271,12.5738299 C12.9575631,10.8996184 11.6710851,11.6027888 10.3547504,11.6012399 C8.62649529,11.5996849 6.90699162,11.6059073 5.18228237,11.4936347 C3.96168523,11.4145513 1.54659435,11.0792908 1.12350833,9.60181214 C0.311662988,6.76280046 3.70585701,7.02757354 5.35889513,6.85023211 C7.49084732,6.62179467 9.9059382,6.44521991 12.0629376,6",
    id: "Path",
    stroke: "#525252",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,19.5000839 C4,19.7760819 3.77621624,20 3.5,20 C3.22379215,20 3,19.7760902 3,19.5000839 C3,19.2239223 3.22378376,19 3.5,19 C3.77620785,19 4,19.2239098 4,19.5000839",
    id: "Path",
    fill: "#525252",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,19.5000839 C7,19.7760819 6.77609024,20 6.50008386,20 C6.22392234,20 6,19.7760902 6,19.5000839 C6,19.2239223 6.22390976,19 6.50008386,19 C6.77608185,19 7,19.2239098 7,19.5000839",
    id: "Path",
    fill: "#525252",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,22.4999161 C4,22.7760777 3.77621624,23 3.5,23 C3.22379215,23 3,22.7760902 3,22.4999161 C3,22.2239181 3.22378376,22 3.5,22 C3.77620785,22 4,22.2239098 4,22.4999161",
    id: "Path",
    fill: "#525252",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,22.4999161 C7,22.7760777 6.77609024,23 6.50008386,23 C6.22392234,23 6,22.7760902 6,22.4999161 C6,22.2239181 6.22390976,22 6.50008386,22 C6.77608185,22 7,22.2239098 7,22.4999161",
    id: "Path",
    fill: "#525252",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,4.50008386 C24,4.77608185 23.7762162,5 23.5,5 C23.2237921,5 23,4.77609024 23,4.50008386 C23,4.22392234 23.2237838,4 23.5,4 C23.7762079,4 24,4.22390976 24,4.50008386",
    id: "Path",
    fill: "#525252",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,11.5000839 C24,11.7762454 23.7762162,12 23.5,12 C23.2237921,12 23,11.7762538 23,11.5000839 C23,11.223914 23.2237838,11 23.5,11 C23.7762079,11 24,11.2239098 24,11.5000839",
    id: "Path",
    fill: "#525252",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#525252",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "18 15.5156442 18 0 32 0 32 29 22.4373289 29"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccesoriesIconGrey);
export default __webpack_public_path__ + "static/media/accesories-icon--grey.f021c785a5272c5262b720562b958b3d.svg";
export { ForwardRef as ReactComponent };